<div class="exception-body notfound">
    <img src="/assets/images/logo-white.svg" alt="diamond-layout" class="logo" />

    <div class="exception-content">
        <div class="exception-title">NOT FOUND</div>
        <div class="exception-detail">Requested resource is not available.</div>
        <a [routerLink]="['/']">Go to Dashboard</a>
    </div>
</div>
